/**
 *
 * DraftControls
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import DeleteButton from 'components/interaction/DeleteButton/index.jsx';
import IconButton from 'components/interaction/IconButton/index.jsx';
import { Link } from 'react-router-dom';
import messages from './messages.js';

function DraftControls(props) {
  const { link, set, onDelete } = props;
  return (
    <div className="">
      <span className="text-muted"><FormattedMessage {...messages.draft} /></span>
      <DeleteButton
        onClick={() => onDelete()}
        icon="ss-trash"
        variant="light"
        size="sm"
        className="ms-4 text-danger"
        confirmTitle={messages.removeTitle}
        confirmText={{ ...messages.removeMessage, values: { title: set.title } }}
      />
      <IconButton as={Link} to={`${link}/${set.id}`} icon="ss-draw color-white" variant="primary" size="sm" className="ms-4" />
    </div>
  );
}

DraftControls.propTypes = {
  set: PropTypes.object,
  link: PropTypes.string,
  onDelete: PropTypes.func,
};

export default DraftControls;
